import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import type { FC } from 'react';
import type { IAnswerElement, IAttribution } from './InsightQA';
import styles from './InsightQAAnswer.module.css';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { Prose } from '@/components/Atoms/Prose/Prose';
interface IInsightQAAnswerProps {
  answer: IAnswerElement;
  onAttributionClick?: (attr: IAttribution) => void;
}
export const InsightQAAnswer: FC<IInsightQAAnswerProps> = t0 => {
  const $ = _c(9);
  const {
    answer,
    onAttributionClick
  } = t0;
  let t1;
  if ($[0] !== answer.text) {
    t1 = <Prose>{answer.text}</Prose>;
    $[0] = answer.text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== answer.attributions || $[3] !== onAttributionClick) {
    t2 = answer.attributions && answer.attributions.length > 0 && <ul className={styles.attributions}>{answer.attributions?.filter(_temp).map((attr_0, i) => <li key={attr_0.id}><Button data-cds-sizing="compact" kind="primary" onClick={() => onAttributionClick?.(attr_0)}>{i + 1}</Button></li>)}</ul>;
    $[2] = answer.attributions;
    $[3] = onAttributionClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== answer.id || $[6] !== t1 || $[7] !== t2) {
    t3 = <Stack className={styles.answer} data-answer-id={answer.id}>{t1}{t2}</Stack>;
    $[5] = answer.id;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(attr) {
  return attr.page !== null;
}